import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@finitless/shared/lib";

/**
 * Hook for fetching payment methods
 * @returns {Object} Payment methods data and loading state
 */
export const usePaymentMethods = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["paymentMethods"],
    queryFn: async () => {
      const response = await apiClient.get("/paymethods");
      return response.result;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false,
  });

  return {
    paymentMethods: data || [],
    isLoading,
    error,
  };
};

export default usePaymentMethods;
